import type { V2Role, V2User } from "@/v2/shared/model";

// Gemockte gebruikers — staat in voor Entra ID/SSO (CB-27). Voor de MVP
// volstaat het onderscheid aanvrager / beheerder (CB-28).
export const V2_USERS: ReadonlyArray<V2User> = [
  {
    id: "u-maarten",
    firstName: "Maarten",
    lastName: "Hendrickx",
    email: "maarten.hendrickx@police.belgium.eu",
    phone: "+32 471 12 34 56",
    role: "requester",
    service: "Wijkteam Antwerpen-Noord",
    serviceContact: "wijkteam.noord@police.belgium.eu",
    organisation: "Politiezone Antwerpen",
    avatarColor: "bg-info-500",
  },
  {
    id: "u-lien",
    firstName: "Lien",
    lastName: "Vandevelde",
    email: "lien.vandevelde@police.belgium.eu",
    phone: "+32 471 23 45 67",
    role: "manager",
    service: "Team functionele ondersteuning",
    serviceContact: "fo.camerabeheer@police.belgium.eu",
    organisation: "Politiezone Antwerpen",
    avatarColor: "bg-primary-500",
  },
  // Tweede beheerder — maakt de gerichte meldingen (PZAO-41) demonstreerbaar:
  // de notificatielijst is per gebruiker en dus niet identiek voor iedereen.
  {
    id: "u-karim",
    firstName: "Karim",
    lastName: "Meziane",
    email: "karim.meziane@police.belgium.eu",
    phone: "+32 471 34 56 78",
    role: "manager",
    service: "Team functionele ondersteuning",
    serviceContact: "fo.camerabeheer@police.belgium.eu",
    organisation: "Politiezone Antwerpen",
    avatarColor: "bg-secondary-500",
  },
];

export function findV2UserById(id: string): V2User | undefined {
  return V2_USERS.find((u) => u.id === id);
}

export function findV2UserByRole(role: V2Role): V2User | undefined {
  return V2_USERS.find((u) => u.role === role);
}
